export enum SessionStorageKeys {
  SELECTEDDATE = 'SELECTEDDATE',
  SELECTEDZONE = 'SELECTEDZONE',
  WEEKLYGANTTFILTERS = 'WEEKLYGANTTFILTERS',
}
